module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "translateForm"
    }
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('form', {
    staticClass: "well form-inline",
    attrs: {
      "id": "form"
    },
    on: {
      "submit": _vm.formSubmit
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textToTranslate),
      expression: "textToTranslate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "input",
      "placeholder": "Enter some word"
    },
    domProps: {
      "value": (_vm.textToTranslate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textToTranslate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.language),
      expression: "language"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "list"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.language = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "en"
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hi"
    }
  }, [_vm._v("Hindi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pa"
    }
  }, [_vm._v("Punjabi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fr"
    }
  }, [_vm._v("French")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "zh"
    }
  }, [_vm._v("Chinese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ja"
    }
  }, [_vm._v("Japanese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mr"
    }
  }, [_vm._v("Marathi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bn"
    }
  }, [_vm._v("Bengali")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "az"
    }
  }, [_vm._v("Azerbaijan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sq"
    }
  }, [_vm._v("Albanian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "am"
    }
  }, [_vm._v("Amharic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ar"
    }
  }, [_vm._v("Arabic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hy"
    }
  }, [_vm._v("Armenian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "af"
    }
  }, [_vm._v("Afrikaans")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "eu"
    }
  }, [_vm._v("Basque")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ba"
    }
  }, [_vm._v("Bashkir")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "be"
    }
  }, [_vm._v("Belarusian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "my"
    }
  }, [_vm._v("Burmese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bg"
    }
  }, [_vm._v("Bulgarian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bs"
    }
  }, [_vm._v("Bosnian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cy"
    }
  }, [_vm._v("Welsh")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hu"
    }
  }, [_vm._v("Hungarian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vi"
    }
  }, [_vm._v("Vietnamese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ht"
    }
  }, [_vm._v("Haitian (Creole)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gl"
    }
  }, [_vm._v("Galician")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "nl"
    }
  }, [_vm._v("Dutch")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mrj"
    }
  }, [_vm._v("Hill Mari")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "el"
    }
  }, [_vm._v("Greek")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ka"
    }
  }, [_vm._v("Georgian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gu"
    }
  }, [_vm._v("Gujarati")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Danish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "he"
    }
  }, [_vm._v("Hebrew")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "yi"
    }
  }, [_vm._v("Yiddish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "id"
    }
  }, [_vm._v("Indonesian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ga"
    }
  }, [_vm._v("Irish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "it"
    }
  }, [_vm._v("Italian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is"
    }
  }, [_vm._v("Icelandic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "es"
    }
  }, [_vm._v("Spanish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "kk"
    }
  }, [_vm._v("Kazakh")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "kn"
    }
  }, [_vm._v("Kannada")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ca"
    }
  }, [_vm._v("Catalan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ky"
    }
  }, [_vm._v("Kyrgyz")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ko"
    }
  }, [_vm._v("Korean")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "la"
    }
  }, [_vm._v("Latin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ml"
    }
  }, [_vm._v("Malayalam")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ne"
    }
  }, [_vm._v("Nepali")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "no"
    }
  }, [_vm._v("Norwegian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fa"
    }
  }, [_vm._v("Persian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pl"
    }
  }, [_vm._v("Polish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pt"
    }
  }, [_vm._v("Portuguese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ru"
    }
  }, [_vm._v("Russian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ta"
    }
  }, [_vm._v("Tamil")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "tr"
    }
  }, [_vm._v("Turkish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ur"
    }
  }, [_vm._v("Urdu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sv"
    }
  }, [_vm._v("Swedish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "te"
    }
  }, [_vm._v("Telugu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gd"
    }
  }, [_vm._v("Scottish")])]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "value": "Translate"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-167531ad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TranslateForm.vue
// module id = 18
// module chunks = 0